import React from "react";

interface MobilePaginationProps {
  page: number; // 0-based
  rowsPerPage: number;
  total: number;

  onChangePage: (nextPage: number) => void;

  style?: React.CSSProperties;
  className?: string;
}

const MobilePagination: React.FC<MobilePaginationProps> = ({
  page,
  rowsPerPage,
  total,
  onChangePage,
  style,
  className,
}) => {
  const safeRows = Math.max(1, rowsPerPage);
  const safeTotal = Math.max(0, total);

  const totalPages = Math.max(1, Math.ceil(safeTotal / safeRows));

  const isPrevDisabled = page <= 0 || safeTotal === 0;
  const isNextDisabled = page >= totalPages - 1 || safeTotal === 0;

  const start = safeTotal === 0 ? 0 : page * safeRows + 1;
  const end = safeTotal === 0 ? 0 : Math.min((page + 1) * safeRows, safeTotal);

  return (
    <div
      className={className}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: 12,
        userSelect: "none",
        ...style,
      }}
      aria-label="Mobile pagination"
    >
      <span style={{ fontSize: 14, color: "#111" }}>
        {start}–{end} de {safeTotal}
      </span>

      <button
        type="button"
        onClick={() => onChangePage(page - 1)}
        disabled={isPrevDisabled}
        aria-label="Página anterior"
        style={{
          width: 36,
          height: 36,
          display: "grid",
          placeItems: "center",
          border: "none",
          background: "transparent",
          cursor: isPrevDisabled ? "default" : "pointer",
          opacity: isPrevDisabled ? 0.35 : 1,
        }}
      >
        {/* chevron left */}
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
          <path
            d="M15 18l-6-6 6-6"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      <button
        type="button"
        onClick={() => onChangePage(page + 1)}
        disabled={isNextDisabled}
        aria-label="Página siguiente"
        style={{
          width: 36,
          height: 36,
          display: "grid",
          placeItems: "center",
          border: "none",
          background: "transparent",
          cursor: isNextDisabled ? "default" : "pointer",
          opacity: isNextDisabled ? 0.35 : 1,
        }}
      >
        {/* chevron right */}
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
          <path
            d="M9 6l6 6-6 6"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
};

export default MobilePagination;
